export const Logo = ({ className = "h-9 w-9", dark = false }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect width="40" height="40" rx="12" fill={dark ? "#FAF8F4" : "#2F5D50"} />
    <path d="M20 8c5.5 6 8.5 10.6 8.5 14.6A8.5 8.5 0 0 1 20 31a8.5 8.5 0 0 1-8.5-8.4C11.5 18.6 14.5 14 20 8Z" fill={dark ? "#2F5D50" : "#FAF8F4"} />
    <path d="M15.5 23.5c1.6 2.6 4.6 3.6 7.8 2.4" stroke={dark ? "#FAF8F4" : "#2F5D50"} strokeWidth="2" strokeLinecap="round" fill="none" />
    <circle cx="28.5" cy="10.5" r="2.2" fill="#C9E4CF" />
  </svg>
);

export const ComingSoon = ({ className = "", label = "Bilde kommer" }) => (
  <div className={`relative overflow-hidden rounded-3xl border border-stone-200 bg-[repeating-linear-gradient(135deg,#F1EEE7_0_14px,#F7F5F0_14px_28px)] flex items-center justify-center ${className}`} data-testid="image-placeholder">
    <div className="text-center">
      <div className="font-heading text-2xl font-extrabold tracking-[0.3em] text-stone-400">COMING SOON</div>
      <div className="mt-1 text-xs text-stone-400">{label}</div>
    </div>
  </div>
);
